import React, { useEffect, useState } from 'react'
import './Home.scss'
import { Link } from 'react-router-dom'
import { GoDotFill } from "react-icons/go";

import { LuArrowUpRight } from "react-icons/lu";
import { MdEventAvailable } from "react-icons/md";
import { MdOutlineEventNote } from "react-icons/md";
import TopEvent from './TopEvent.jsx'
import { ResponsiveContainer, Tooltip, Area, AreaChart, CartesianGrid, XAxis, YAxis, Bar, BarChart } from "recharts";
import { FiUsers } from "react-icons/fi";
import axios from 'axios';
import Chart from "react-apexcharts";
import ActivityCard from './ActivityCard';
import UserTable from './UserTable.jsx';




function Home() {
    const [chartData3, setChartData3] = useState([]);
    const [chartData1, setChartData1] = useState([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [dataRatio, setDataRatio] = useState(0);
    const [totalUsers1, setTotalUsers1] = useState(0);
    const [percentageIncrease, setPercentageIncrease] = useState(0);
    const [chartData2, setChartData2] = useState([]);
    const [totalUsers2, setTotalUsers2] = useState(0);
    // const [percentageIncrease1, setPercentageIncrease1] = useState("0.00");
    const [dataReady, setDataReady] = useState(false); // Flag to control chart rendering
    const [dataLengthRatio, setDataLengthRatio] = useState(0);
    const [graphHeight, setGraphHeight] = useState("auto");
    // https://ridehire-backend-2.onrender.com/host/allUpcomingEvent
    //https://ridehire-backend-2.onrender.com/host/allSuccess
    //https://ridehire-backend-2.onrender.com/host/allRejectedEvent
    //https://ridehire-backend-2.onrender.com/host/allProcessingEvent


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get("https://ridehire-backend-2.onrender.com/user/getAllUser");
                const users = response.data.data || [];

                setTotalUsers(users.length || 0);

                // Define expected user count for ratio calculation
                const expectedUsers = 100;
                const ratio = users.length / expectedUsers;
                setDataRatio((ratio * 100).toFixed(2)); // Convert ratio to percentage

                // Generate fluctuating data for chart
                const formattedData = users.map((_, index) => ({
                    value: (index % 2 === 0 ? 1 : -1) * (users.length * 1.5) * (Math.random() * 2 + 1), // Dynamic scaling
                    name: `User ${index + 1}`
                }));

                setChartData3(formattedData);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData();

        // Live chart fluctuation
        const interval = setInterval(() => {
            setChartData3(prevData =>
                prevData.map(point => ({
                    ...point,
                    value: point.value + (Math.random() * 10 - 5), // Gentle variation (-5 to +5)
                }))
            );
        }, 1200);

        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        const fetchSuccessData = async () => {
            try {
                const response = await fetch("https://ridehire-backend-2.onrender.com/host/allSuccess");
                const data = await response.json();

                if (Array.isArray(data)) {
                    const totalSuccessEvents = data.length;
                    const previousTotal = Math.max(1, Math.round(totalSuccessEvents * 0.6));
                    const percentageChange = ((totalSuccessEvents - previousTotal) / previousTotal) * 100;

                    setTotalUsers1(totalSuccessEvents);
                    setPercentageIncrease(percentageChange.toFixed(2));

                    // Define expected events count for ratio calculation
                    const expectedEvents = 100;
                    const ratio = totalSuccessEvents / expectedEvents;
                    setDataRatio((ratio * 100).toFixed(2)); // Convert to percentage format

                    // Generate fluctuating data for chart (same logic as first useEffect)
                    const formattedData = new Array(10).fill(0).map((_, index) => ({
                        name: `Event ${index + 1}`,
                        value: (index % 2 === 0 ? 1 : -1) * (totalSuccessEvents * 1.5) * (Math.random() * 2 + 1), // Dynamic scaling
                    }));

                    setChartData1(formattedData);
                } else {
                    console.error("Invalid API response:", data);
                }
            } catch (error) {
                console.error("Error fetching success events:", error);
            }
        };

        fetchSuccessData();

        // Live chart fluctuation (same pattern as first useEffect)
        const interval = setInterval(() => {
            setChartData1(prevData =>
                prevData.map(point => ({
                    ...point,
                    value: point.value + (Math.random() * 10 - 5), // Gentle variation (-5 to +5)
                }))
            );
        }, 1200);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get("https://ridehire-backend-2.onrender.com/host/allEvent");
                const events = response.data.data || [];

                setTotalUsers2(events.length || 0);

                // Format data for the chart
                const formattedData = events.map((item, index) => ({
                    value: (index % 2 === 0 ? 1 : -1) * (item.value || 0) * 20,
                    name: item.name || `Event ${index + 1}`
                }));

                const expectedLength = 100;
                const ratio = events.length / expectedLength;
                setDataLengthRatio((ratio * 100).toFixed(2)); // Convert to percentage format

                if (formattedData.length > 0) {
                    setChartData2(formattedData);
                    setDataReady(true);
                }
            } catch (error) {
                console.error("Error fetching event data:", error);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        if (!dataReady || chartData2.length === 0) return;

        const interval = setInterval(() => {
            setChartData2(prevData =>
                prevData.map(point => ({
                    ...point,
                    value: point.value + (Math.random() * 20 - 10), // Keep the fluctuation logic
                }))
            );
        }, 1200);

        return () => clearInterval(interval);
    }, [dataReady, chartData2]);

    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'area',
                height: 350,
                background: 'transparent', // ✅ Remove full background color
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 500,
                    animateGradually: { enabled: true, delay: 100 },
                    dynamicAnimation: { enabled: true, speed: 300 },
                },
                dropShadow: {
                    enabled: true,
                    top: 2,
                    left: 0,
                    blur: 3, // Reduce blur for a softer effect
                    opacity: 0.1, // Lower opacity
                    color: '#000',
                },

            },
            stroke: {
                curve: 'smooth',
                width: 3, // Make lines thinner like Graph 1
                dashArray: [0, 0, 0], // Remove dashed lines
            },


            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark', // Change from 'dark' to 'light' for better contrast
                    shadeIntensity: 0.8,
                    opacityFrom: 0.25, // Softer gradient
                    opacityTo: 0.2,  // Light fade at the bottom
                    stops: [0, 50, 100],
                },
            },

            colors: ['#00BFFF', '#6a0dad', '#FF5733'], // Match with Graph 1’s theme

            dataLabels: { enabled: false },
            grid: {
                borderColor: '#e0e0e0', // Lighter grid lines
                strokeDashArray: 3,
                backgroundColor: 'transparent' // ✅ No full chart background color
            },
            markers: { size: 3, hover: { size: 5 } },
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                title: { text: 'Months' },
            },
            yaxis: {
                title: { text: 'Amount (USD)' },
                labels: { formatter: (value) => Math.round(value) },
                min: 0
            },
            tooltip: {
                enabled: true,
                theme: 'light',
            },
        },
    });

    useEffect(() => {
        let interval;
        const fetchData = async () => {
            try {
                const [usersRes, hostsRes, eventsRes] = await Promise.all([
                    axios.get('https://ridehire-backend-2.onrender.com/user/getAllUser'),
                    axios.get('https://ridehire-backend-2.onrender.com/host/allSuccess'),
                    axios.get('https://ridehire-backend-2.onrender.com/host/allEvent'),
                ]);

                const usersData = usersRes.data.data.length;
                const hostsData = hostsRes.data.length;
                const eventsData = eventsRes.data.data.length;

                // Function to generate slight fluctuations in the data
                const addFluctuation = (base, range, zigzag = false, prevData = []) => {
                    return Array.from({ length: 12 }, (_, i) => {
                        const fluctuation = (Math.random() - 0.5) * (range * 0.2);
                        // Small random fluctuation
                        const smoothStep = prevData[i] ? (prevData[i] - base) * 0.05 : 0; // Gradual movement

                        return base + smoothStep + fluctuation +
                            (zigzag ? Math.sin(i * 0.8 + Math.random() * 0.2) * (range / 3) : 0); // Smoother zigzag
                    });
                };


                // Updating the chart with the new fluctuated data
                setChartData((prev) => ({
                    ...prev,
                    series: [
                        { name: 'Users', data: addFluctuation(usersData, 10), type: 'area' },
                        { name: 'Hosts', data: addFluctuation(hostsData, 15), type: 'area' },
                        { name: 'Events (Ratio)', data: addFluctuation(eventsData / 10, 8, true), type: 'area' }, // More zigzagging effect
                    ],
                }));
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
        };

        fetchData(); // Initial data fetch

        interval = setInterval(fetchData, 5000); // Fetch new data every 5 seconds

        return () => clearInterval(interval); // Cleanup interval on component unmount
    }, []);

    const data = [
        { day: "S", profit: 40 },
        { day: "M", profit: 35 },
        { day: "T", profit: 60 },
        { day: "W", profit: 90 },
        { day: "T", profit: 55 },
        { day: "F", profit: 50 },
        { day: "S", profit: 70 },
    ];

    const [eventCounts, setEventCounts] = useState({
        total: 0,
        success: 0,
        processing: 0,
        rejected: 0,
        upcoming: 0
    });

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                // Fetch all APIs simultaneously
                const [upcoming, success, rejected, processing] = await Promise.all([
                    fetch("https://ridehire-backend-2.onrender.com/host/allUpcomingEvent").then(res => res.json()),
                    fetch("https://ridehire-backend-2.onrender.com/host/allSuccess").then(res => res.json()),
                    fetch("https://ridehire-backend-2.onrender.com/host/allRejectedEvent").then(res => res.json()),
                    fetch("https://ridehire-backend-2.onrender.com/host/allProcessingEvent").then(res => res.json())
                ]);

                // Extract event lengths
                const upcomingCount = upcoming.data?.length || 0;
                console.log(rejected);
                const successCount = success?.length || 0;
                console.log(success);

                const rejectedCount = rejected?.length || 0;
                const processingCount = processing?.length || 0;

                // Calculate total events
                const totalEvents = upcomingCount + successCount + rejectedCount + processingCount;

                // Update state
                setEventCounts({
                    total: totalEvents,
                    success: successCount,
                    processing: processingCount,
                    rejected: rejectedCount,
                    upcoming: upcomingCount
                });

            } catch (error) {
                console.error("Error fetching event data:", error);
            }
        };

        fetchEventData();
    }, []);





    return (
        <>
            <div className="home-container">

                <div className='mx-3 mt-3 ' >

                    <div className="welcome h5 m-0" >
                        Welcome back, Raj Miyani !

                    </div>
                    <p style={{ fontSize: "14px", color: "#8c9097" }}>Track your sales activity, leads and deals here.</p>

                    <div className="container-fluid">
                        <div className="row ">
                            <div className="col-xl-3 col-md-6 col-12 p-1">
                                <div className="card shadow-lg h-100 ">
                                    <div className="bg-img p-3 h-100 d-flex flex-column justify-content-between rounded-class">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                                            {/* Left Side Content */}
                                            <div className="content text-white mt-3" style={{ flex: "1" }}>
                                                <h5 className="fw-bold">Your target is incomplete</h5>
                                                <p className="mb-2" style={{ fontSize: "13px" }}>
                                                    You have completed 48% of the given target, you can also check your status.
                                                </p>
                                                <Link href="#" className="text-white">Click here</Link>
                                            </div>

                                            {/* Right Side Chart */}
                                            <div className="chart-container">
                                                <div className="chart-text">48%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col-xl-3 col-md-6 col-12 p-1">
                                <div className="bg-white shadow rounded-2xl p-3 rounded-class">
                                    {/* Top Section: Icon + Text */}
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="p-3 rounded-5" style={{ backgroundColor: "#00d47c9d" }}>
                                                <FiUsers className="text-purple-600" size={24} />
                                            </div>
                                            <div>
                                                <p className="text-gray-500 text-sm m-1">Total Customers</p>
                                                <h2 className="text-2xl font-bold">{totalUsers.toLocaleString()}</h2>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Live Zigzag Graph with Ratio-based Data */}
                                    <div className="my-3">
                                        {chartData3.length > 0 ? (
                                            <ResponsiveContainer width="100%" height={60}>
                                                <AreaChart data={chartData3}>
                                                    <defs>
                                                        <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                                            <stop offset="5%" stopColor="#00D47B" stopOpacity={0.6} />
                                                            <stop offset="95%" stopColor="#00D47B" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>

                                                    <Area
                                                        type="monotone"
                                                        dataKey="value"
                                                        stroke="#00D47B"
                                                        strokeWidth={3}
                                                        fill="url(#colorGreen)"
                                                        animationDuration={600} // Smooth animation
                                                    />

                                                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                    <XAxis hide />
                                                    <YAxis hide />
                                                    <Tooltip />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            <p className="text-gray-400 text-sm text-center">No data available</p>
                                        )}
                                    </div>

                                    {/* Bottom Section */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2 text-purple-600 text-sm font-semibold cursor-pointer">
                                            <span>View All</span>
                                            <LuArrowUpRight size={16} />
                                        </div>
                                        <span className="text-green-500 font-semibold">+{dataRatio}%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6 col-12 p-1">
                                <div className="bg-white shadow rounded-3xl p-3 transition-all rounded-class hover:shadow-xl">
                                    {/* Top Section: Icon + Text */}
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="p-3 rounded-circle  flex items-center justify-center faUser" >
                                                <MdEventAvailable className="text-green-700" size={24} />
                                            </div>
                                            <div>
                                                <p className="text-gray-500 text-sm m-1">Succesful Event</p>
                                                <h2 className="text-2xl font-bold">{totalUsers1.toLocaleString()}</h2>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Fluctuating Live Graph (Stable Dots) */}
                                    <div className="my-3">
                                        <ResponsiveContainer width="100%" height={60}>
                                            <AreaChart data={chartData1}>
                                                <defs>
                                                    <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="5%" stopColor="#962bcc" stopOpacity={0.8} />
                                                        <stop offset="95%" stopColor="#962bcc" stopOpacity={0} />
                                                    </linearGradient>
                                                </defs>

                                                <Area
                                                    type="monotone"
                                                    dataKey="value"
                                                    stroke="#962bcc"
                                                    strokeWidth={3}
                                                    fill="url(#colorGreen)"
                                                    animationDuration={600} // Smooth animation effect
                                                />

                                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                <XAxis hide />
                                                <YAxis hide />
                                                <Tooltip />
                                            </AreaChart>
                                        </ResponsiveContainer>
                                    </div>

                                    {/* Bottom Section */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2 text-green-700 text-sm font-semibold cursor-pointer">
                                            <span>View All</span>
                                            <LuArrowUpRight size={16} />
                                        </div>
                                        <span className="text-green-500 font-semibold">+{percentageIncrease}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-md-6 col-12 p-1 ">
                                <div className="bg-white shadow rounded-3xl p-3 transition-all rounded-class hover:shadow-xl">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="p-3 rounded-circle  flex items-center justify-center faCalendar" >
                                                <MdOutlineEventNote className="text-green-700" size={24} />
                                            </div>
                                            <div>
                                                <p className="text-gray-500 text-sm m-1">Total Events</p>
                                                <h2 className="text-2xl font-bold">{totalUsers2.toLocaleString()}</h2>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-3">
                                        {dataReady && chartData2.length > 0 ? (
                                            <ResponsiveContainer width="100%" height={60}>
                                                <AreaChart data={chartData2}>
                                                    <defs>
                                                        <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                                            <stop offset="5%" stopColor="#28d2cf" stopOpacity={0.8} />
                                                            <stop offset="95%" stopColor="#28d2cf" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>
                                                    <Area
                                                        type="monotone"
                                                        dataKey="value"
                                                        stroke="#28d2cf"
                                                        strokeWidth={3}
                                                        fill="url(#colorGreen)"
                                                        animationDuration={600}
                                                    />
                                                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                    <XAxis hide />
                                                    <YAxis hide />
                                                    <Tooltip />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            <p className="text-gray-400 text-sm text-center">No data available</p>
                                        )}
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2 text-green-700 text-sm font-semibold cursor-pointer">
                                            <span>View All</span>
                                        </div>
                                        <span className="text-green-500 font-semibold">+{dataLengthRatio}%</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="main-chart-container   mt-4">
                        <div className="container-fluid ">
                            <div className="row justify-content-center">
                                <div className="col-xl-3 col-lg-4 col-md-12 col-12   p-1">
                                    <TopEvent />
                                </div>
                                <div className="col-xl-6 col-lg-8 col-md-12 col-12 p-1 rounded-xl">

                                    <div className="p-3 bg-white shadow-lg rounded-class w-full max-w-4xl mx-auto ">
                                        <h2 className="h5 font-semibold text-gray-800 head-title">Revenue Analytics</h2>
                                        <p className="text-gray-500 text-sm mb-3 ">Live Revenue Analytics (Users, Hosts & Events)</p>
                                        <Chart options={chartData.options} series={chartData.series} type="line" height={350} />
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-12 col-md-12 col-12 p-1 d-xl-block d-none  ">
                                    <div className="bg-white p-3 rounded-xl rounded-class">
                                        <h5 className='m-0 head-title'>Project Status</h5>
                                        <div className="d-flex align-items-center mt-1">
                                            <h3>{eventCounts.total}</h3>
                                            <p className='pt-2 ps-2 text-dark-emphasis'>Total Events</p>
                                        </div>
                                        <div className="multi-colored-line"></div>

                                        <div className="d-flex justify-content-between align-items-center mt-4">
                                            <div className="d-flex align-items-center">
                                                <GoDotFill className='dealsDot' />
                                                <p className='m-0' style={{ fontSize: "14px" }}>Successful Deals</p>
                                            </div>
                                            <div className="dealsCount">{eventCounts.success} deals</div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <div className="d-flex align-items-center">
                                                <GoDotFill className='dealsDot1' />
                                                <p className='m-0' style={{ fontSize: "14px" }}>Processing Deals</p>
                                            </div>
                                            <div className="dealsCount">{eventCounts.processing} deals</div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <div className="d-flex align-items-center">
                                                <GoDotFill className='dealsDot2' />
                                                <p className='m-0' style={{ fontSize: "14px" }}>Rejected Deals</p>
                                            </div>
                                            <div className="dealsCount">{eventCounts.rejected} deals</div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <div className="d-flex align-items-center">
                                                <GoDotFill className='dealsDot3' />
                                                <p className='m-0' style={{ fontSize: "14px" }}>Upcoming Deals</p>
                                            </div>
                                            <div className="dealsCount">{eventCounts.upcoming} deals</div>
                                        </div>
                                    </div>
                                    <div className="ps-3 pt-3 pe-3 bg-white rounded-lg shadow-md w-full max-w-xs mt-3 rounded-class">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="head-title font-bold"> Profit Earned</h5>
                                            {/* <button className="text-gray-400 text-sm">View All ▼</button> */}
                                        </div>

                                        {/* ✅ Wrap the BarChart inside ResponsiveContainer */}
                                        <ResponsiveContainer width="100%" height={150}>
                                            <BarChart data={data} barSize={8}>
                                                <XAxis dataKey="day" axisLine={false} tick={{ fontSize: 14 }} tickLine={false} />
                                                <YAxis hide />
                                                <Tooltip />
                                                <Bar dataKey="profit" fill="#00D47B" radius={[6, 6, 0, 0]} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                <div className="d-xl-none d-block">
                                    <div className="col-xl-3 col-lg-12 w-100 col-md-12 col-12 p-1  ">
                                        <div className="container-lg-fluid">

                                            <div className="row ">

                                                <div className="col-6 p-0 pe-2">
                                                    <div className="bg-white p-3   rounded-xl rounded-class">

                                                        <h5 className='m-0 head-title'>Project Status</h5>
                                                        <div className="d-flex align-items-center mt-1">
                                                            <h3>{eventCounts.total}</h3>
                                                            <p className='pt-2 ps-2 text-dark-emphasis'>Total Events</p>
                                                        </div>
                                                        <div className="multi-colored-line"></div>

                                                        <div className="d-flex justify-content-between align-items-center mt-4">
                                                            <div className="d-flex align-items-center">
                                                                <GoDotFill className='dealsDot' />
                                                                <p className='m-0' style={{ fontSize: "14px" }}>Successful Deals</p>
                                                            </div>
                                                            <div className="dealsCount">{eventCounts.success} deals</div>
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <div className="d-flex align-items-center">
                                                                <GoDotFill className='dealsDot1' />
                                                                <p className='m-0' style={{ fontSize: "14px" }}>Processing Deals</p>
                                                            </div>
                                                            <div className="dealsCount">{eventCounts.processing} deals</div>
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <div className="d-flex align-items-center">
                                                                <GoDotFill className='dealsDot2' />
                                                                <p className='m-0' style={{ fontSize: "14px" }}>Rejected Deals</p>
                                                            </div>
                                                            <div className="dealsCount">{eventCounts.rejected} deals</div>
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <div className="d-flex align-items-center">
                                                                <GoDotFill className='dealsDot3' />
                                                                <p className='m-0' style={{ fontSize: "14px" }}>Upcoming Deals</p>
                                                            </div>
                                                            <div className="dealsCount">{eventCounts.upcoming} deals</div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-6 ps-3 pt-3 pe-3  bg-white rounded-lg shadow-md w-full max-w-xs  mt-0 rounded-class">

                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <h5 className="head-title font-bold"> Profit Earned</h5>
                                                        {/* <button className="text-gray-400 text-sm">View All ▼</button> */}
                                                    </div>

                                                    {/* ✅ Wrap the BarChart inside ResponsiveContainer */}
                                                    <ResponsiveContainer width="100%" height={150}>
                                                        <BarChart data={data} barSize={8}>
                                                            <XAxis dataKey="day" axisLine={false} tick={{ fontSize: 14 }} tickLine={false} />
                                                            <YAxis hide />
                                                            <Tooltip />
                                                            <Bar dataKey="profit" fill="#00D47B" radius={[6, 6, 0, 0]} />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="user-event-conteiner mt-4">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-9 col-lg-8 col-12  p-1 d-block">
                                    <UserTable setGraphHeight={setGraphHeight} />
                                </div>
                                <div className="col-xl-3 col-lg-4 col-0  p-1 d-lg-block d-none">
                                    <ActivityCard graphHeight={graphHeight} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
export default Home